import { useFeatureFlagEnabled } from '@posthog/react/slim';

import { JdpAbTestNewComponents, useMultipleVariantData } from '@pflegia/feature-flags';
import { useAuth } from '@pflegia/ui/contexts/auth.context';

import { useRouterHelper } from '@shared/hooks/use-router-helper';

export interface JdpAbTestVariantResult {
  isTest: boolean | null;
  isFlagReady: boolean;
}

const useJdpAbTestVariant = (isInitiative: boolean, isJobPositionPaused: boolean): JdpAbTestVariantResult => {
  const authenticated = useAuth();
  const { isJobDetailsPage } = useRouterHelper();

  const { isTest } = useMultipleVariantData(JdpAbTestNewComponents.Name);
  const isFlagEnabled = useFeatureFlagEnabled(JdpAbTestNewComponents.Name);

  if (authenticated || !isJobDetailsPage || isInitiative || isJobPositionPaused) return { isTest: null, isFlagReady: true };

  return {
    isTest,
    isFlagReady: isFlagEnabled !== undefined,
  };
};

export default useJdpAbTestVariant;
